import getApiClient from '@/plugins/api'

export default {
  loadBoost: function () {
    const self = this,
      api = getApiClient(self.$store),
      boostId = self.$route.params.id

    self.$store.commit('startLoading')
    api.get(`boosts/${boostId}/detailed`)
      .then(response => {
        self.boost = response.data
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        self.$store.commit('stopLoading')
      })
  }
}
